import React, { Fragment } from 'react';
import { startCase } from 'lodash';

import { env } from '~/commons/config';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FieldArrayCards from '../FieldArrayCards.jsx';

const arrDefaults = {
  paymentMethod: {
    payment: '',
    card: '',
    bank: '',
    cheque: '',
    paymentType: '',
    amount: 0,
    remarks: '',
    receiptNumber: '',
  },
};

const FieldPaymentCards = ({ paymentMethod = arrDefaults.paymentMethod, quotation }) => (
  <Fragment>
    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
      {quotation ? 'Payment Method (For Convertion)' : 'Payment Method'}
    </h6>
    <div className="row">
      <div className="col">
        <FieldArrayCards
          name="paymentMethod"
          push={paymentMethod}
          disabledForItem={(s) => !_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}
        >
          {(s, i) => (
            <>
              <div className="row">
                <div className="col">
                  <FormGroup
                    name={`paymentMethod.${i}.payment`}
                    label="Payment Type"
                    as="select"
                    disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}>
                    <option value="">-</option>
                    {(env.paymentType ?? []).map((v) => (
                      <option key={v} value={v}>
                        {startCase(v)}
                      </option>
                    ))}
                  </FormGroup>
                </div>
              </div>
              {s.payment === 'card' && (
                <div className="row">
                  <div className="col">
                    <FormGroup
                      name={`paymentMethod.${i}.card`}
                      label="Card Type"
                      as="select"
                      disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}>
                      <option value="">-</option>
                      {(env.cardType ?? []).map((v) => (
                        <option key={v} value={v}>
                          {startCase(v)}
                        </option>
                      ))}
                    </FormGroup>
                  </div>
                </div>
              )}
              {s.payment === 'cheque' && (
                <div className="row">
                  <div className="col">
                    <FormGroup
                      name={`paymentMethod.${i}.bank`}
                      label="Bank Name"
                      disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}
                    />
                  </div>
                  <div className="col">
                    <FormGroup
                      name={`paymentMethod.${i}.cheque`}
                      label="Cheque Number"
                      disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}
                    />
                  </div>
                </div>
              )}
              {s.payment === 'other' && (
                <div className="row">
                  <div className="col">
                    <FormGroup
                      name={`paymentMethod.${i}.paymentType`}
                      label="Payment Type"
                      disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))} />
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col">
                  <FormGroup
                    name={`paymentMethod.${i}.amount`}
                    type="number"
                    label="Amount"
                    disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup
                    name={`paymentMethod.${i}.receiptNumber`}
                    label="Receipt Number"
                    disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <FormGroup
                    name={`paymentMethod.${i}.remarks`}
                    label="Remarks"
                    as="textarea"
                    disabled={!_.isEmpty(_.get(s, 'erpSync.lastSuccess'))}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name={`paymentMethod.${i}.erpSync.lastSuccess`} disabled label="Last Success" />
                </div>
                <div className="col">
                  <FormGroup name={`paymentMethod.${i}.erpSync.lastSync`} disabled label="Last Attempt" />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name={`paymentMethod.${i}.erpSync.errType`} disabled label="Error Type" />
                </div>
                <div className="col">
                  <FormGroup name={`paymentMethod.${i}.erpSync.message`} disabled label="Message" />
                </div>
              </div>
            </>
          )}
        </FieldArrayCards>
      </div>
    </div>
  </Fragment>
);

export default FieldPaymentCards;
